var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "aml" },
    [
      _c(
        "md-button",
        {
          staticClass: "aml-icon",
          class: { "aml-active": _vm.isShowed },
          on: { click: _vm.toggleShow }
        },
        [
          _c(
            "span",
            { staticClass: "text_small", style: { color: "" + _vm.numColor } },
            [
              _vm._v("Risk score: "),
              _c(
                "span",
                {
                  staticClass: "aml-number",
                  style: { color: "" + _vm.numColor }
                },
                [_vm._v(_vm._s(_vm.riskScore))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "md-icon",
            { staticClass: "arrow-down-icon-aml md-icon-size-065x" },
            [
              _c(
                "svg",
                {
                  attrs: {
                    height: "24",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowed,
              expression: "isShowed"
            }
          ],
          staticClass: "aml-container"
        },
        [
          _vm._l(_vm.risks, function(risk, index) {
            return _c(
              "div",
              { key: "aml-" + index, staticClass: "aml-col" },
              _vm._l(risk, function(innerRisk, index) {
                return _c(
                  "div",
                  { key: "innder-" + index, staticClass: "aml-row" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "aml-row-inner",
                        class: { opacityed: +innerRisk[1] === 0.0 }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "text_small",
                            class: {
                              hight: _vm.higthRisk.includes(innerRisk[0])
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("replaceUnderscore")(innerRisk[0]))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "text_small",
                            class: {
                              hight: _vm.higthRisk.includes(innerRisk[0])
                            }
                          },
                          [_vm._v(_vm._s(innerRisk[1]))]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "aml-col" },
            [
              _c("AmlIndicatore", {
                attrs: { value: _vm.riskScore, higth: _vm.isHigthRiskscore }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d8238e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8238e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Aml.vue
// module id = Kzg3
// module chunks = 1